import UpsellView from "compid/shared/views/UpsellView";
import React from "react";

/**
 * @function NewAutopayUpsellView 
 * @param {OBJECT} props - Default React.Components props OBJECT
 * @returns {React.Component}
 * @example
 * <NewAutopayUpsellView />
 */

export default function NewAutopayUpsellView(props) {
  return (
    <UpsellView 
      dataPoint={ props.dataPoint }
      biller={ props.biller }
      text="Add autopay so your bill is paid on time, every time."
      textClass="blue-text"
      onClick={ props.onClick }/>
  )
}
